module.exports = __webpack_public_path__ + "static/media/updated_new_logo.fb31c99b.svg";